export const currentUser = {
   name: 'Alex Chen',
   username: '@alexstyle',
   streak: 47,
   points: 2840,
   level: 'Gold'
};

export const posts = [
   {
      id: 1,
      user: 'Emma Wilson',
      username: '@emmastyle',
      image: '/api/placeholder/300/400',
      likes: 24,
      outfit: ['Black blazer - Zara $89', 'White tee - H&M $12', 'Dark jeans - Levi\'s $98'],
      occasion: 'Work Meeting',
      music: 'Confident - Demi Lovato',
      collaborators: ['@fashionista_sarah']
   },
   {
      id: 2,
      user: 'Marcus Johnson',
      username: '@marcusfits',
      image: '/api/placeholder/300/400',
      likes: 18,
      outfit: ['Navy hoodie - Nike $65', 'Black joggers - Adidas $55', 'White sneakers - Air Force 1 $90'],
      occasion: 'Casual Day',
      music: 'Good Vibes - Chris Brown'
   }
];

export const savedOutfits = [
   { date: '2025-09-01', occasion: 'First Day of September', items: ['White Button Down', 'Dark Jeans', 'White Sneakers'], color: '#3B82F6' },
   { date: '2025-09-03', occasion: 'Coffee Date', items: ['Black Turtleneck', 'Midi Skirt', 'Ankle Boots'], color: '#EF4444' },
   { date: '2025-09-05', occasion: 'Work Meeting', items: ['Navy Blazer', 'White Tee', 'Trousers'], color: '#10B981' },
   { date: '2025-09-08', occasion: 'Weekend Casual', items: ['Oversized Hoodie', 'Leggings', 'Chunky Sneakers'], color: '#F59E0B' },
   { date: '2025-09-12', occasion: 'Dinner Out', items: ['Black Dress', 'Heels', 'Statement Earrings'], color: '#8B5CF6' },
   { date: '2025-09-15', occasion: 'Shopping Trip', items: ['Denim Jacket', 'Crop Top', 'Mom Jeans'], color: '#EC4899' },
   { date: '2025-09-18', occasion: 'Work Presentation', items: ['Pencil Skirt', 'Silk Blouse', 'Pointed Heels'], color: '#06B6D4' },
   { date: '2025-09-20', occasion: 'Friend\'s Birthday', items: ['Party Dress', 'Strappy Heels', 'Clutch Bag'], color: '#F97316' },
   { date: '2025-09-22', occasion: 'Gym Session', items: ['Sports Bra', 'High Waist Leggings', 'Running Shoes'], color: '#84CC16' },
   { date: '2025-08-28', occasion: 'Beach Day', items: ['Bikini', 'Cover-up', 'Sandals'], color: '#06B6D4' },
   { date: '2025-08-25', occasion: 'Art Gallery', items: ['Midi Dress', 'Cardigan', 'Loafers'], color: '#8B5CF6' },
   { date: '2025-08-22', occasion: 'Brunch', items: ['Sundress', 'Denim Jacket', 'White Sneakers'], color: '#F59E0B' },
   { date: '2025-08-19', occasion: 'Work Conference', items: ['Power Suit', 'Blouse', 'Heels'], color: '#EF4444' },
   { date: '2025-08-16', occasion: 'Date Night', items: ['Little Black Dress', 'Red Heels', 'Gold Jewelry'], color: '#DC2626' },
   { date: '2025-08-13', occasion: 'Family BBQ', items: ['Floral Dress', 'Cardigan', 'Wedge Sandals'], color: '#10B981' },
   { date: '2025-08-10', occasion: 'Movie Night', items: ['Cozy Sweater', 'Jeans', 'Ugg Boots'], color: '#6B7280' },
   { date: '2025-08-07', occasion: 'Job Interview', items: ['Navy Suit', 'White Shirt', 'Black Pumps'], color: '#1E40AF' },
   { date: '2025-08-04', occasion: 'Concert', items: ['Band Tee', 'Leather Jacket', 'Black Jeans'], color: '#374151' },
   { date: '2025-08-01', occasion: 'Summer Party', items: ['Maxi Dress', 'Strappy Sandals', 'Sun Hat'], color: '#F472B6' }
];

export const interests = [
   { brand: 'Zara', item: 'Oversized Blazer', price: '$89', image: '/api/placeholder/150/200' },
   { brand: 'Nike', item: 'Air Max 90', price: '$120', image: '/api/placeholder/150/200' },
   { brand: 'H&M', item: 'Cropped Cardigan', price: '$25', image: '/api/placeholder/150/200' }
];

export const closetCategories = {
   shirts: [
      { item: 'White Button Down', brand: 'Uniqlo', worn: '3 days ago' },
      { item: 'Black Turtleneck', brand: 'COS', worn: '1 week ago' },
      { item: 'Navy Blazer', brand: 'Zara', worn: '5 days ago' },
      { item: 'Oversized Hoodie', brand: 'Nike', worn: '2 days ago' }
   ],
   shoes: [
      { item: 'White Sneakers', brand: 'Adidas', worn: 'Yesterday' },
      { item: 'Black Boots', brand: 'Dr. Martens', worn: '2 days ago' },
      { item: 'Heels', brand: 'Jimmy Choo', worn: '1 week ago' },
      { item: 'Running Shoes', brand: 'Nike', worn: '3 days ago' }
   ],
   accessories: [
      { item: 'Silver Watch', brand: 'Casio', worn: 'Today' },
      { item: 'Leather Belt', brand: 'Coach', worn: '3 days ago' },
      { item: 'Statement Earrings', brand: 'Tiffany', worn: '1 week ago' },
      { item: 'Clutch Bag', brand: 'Gucci', worn: '2 weeks ago' }
   ]
};

export const badges = [
   {
      name: '7-Day Streak Master',
      earned: '2025-01-20',
      points: 100,
      description: 'Posted daily outfits for 7 consecutive days',
      requirement: 'Maintain a 7-day posting streak',
      icon: '🔥',
      rarity: 'Common'
   },
   {
      name: 'Style Influencer',
      earned: '2025-01-18',
      points: 250,
      description: 'Received 100+ likes across all posts',
      requirement: 'Get 100+ total likes on your outfits',
      icon: '✨',
      rarity: 'Rare'
   },
   {
      name: 'Brand Explorer',
      earned: '2025-01-15',
      points: 150,
      description: 'Added items from 10 different brands to interests',
      requirement: 'Explore 10+ different clothing brands',
      icon: '🏷️',
      rarity: 'Uncommon'
   },
   {
      name: 'Trendsetter',
      earned: '2025-01-12',
      points: 300,
      description: 'First to post a trending outfit style',
      requirement: 'Be among the first to showcase new trends',
      icon: '👑',
      rarity: 'Epic'
   },
   {
      name: 'Social Butterfly',
      earned: '2025-01-10',
      points: 200,
      description: 'Collaborated with 5 different users',
      requirement: 'Tag 5+ different friends in posts',
      icon: '🦋',
      rarity: 'Uncommon'
   },
   {
      name: 'Shopaholic',
      earned: null,
      points: 500,
      description: 'Make 10 purchases through the app',
      requirement: 'Complete 10 purchases via ILYO shop',
      icon: '🛍️',
      rarity: 'Legendary',
      progress: '7/10'
   },
   {
      name: 'Weather Warrior',
      earned: null,
      points: 75,
      description: 'Post outfits in 5 different weather conditions',
      requirement: 'Adapt your style to various weather',
      icon: '🌤️',
      rarity: 'Common',
      progress: '3/5'
   },
   {
      name: 'Charity Champion',
      earned: null,
      points: 500,
      description: 'Donated 10+ clothing items to charity',
      requirement: 'Sell 10 items through ILYO for charity',
      icon: '💝',
      rarity: 'Epic',
      progress: '7/10'
   }
];

export const inspirationalMessages = [
   "Your style tells your story ✨",
   "Every outfit is a chance to shine 🌟",
   "Fashion is your daily canvas 🎨",
   "Express yourself boldly today 💫",
   "Style is a way to say who you are 👑"
];

export const sampleUsers = [
   { name: 'Emma Wilson', username: '@emmastyle', followers: '2.4K', following: true },
   { name: 'Marcus Johnson', username: '@marcusfits', followers: '1.8K', following: false },
   { name: 'Sarah Chen', username: '@sarahchic', followers: '3.2K', following: true },
   { name: 'Alex Rivera', username: '@alexfashion', followers: '892', following: false },
   { name: 'Jordan Kim', username: '@jordanstyle', followers: '4.1K', following: false },
   { name: 'Taylor Swift', username: '@taylorswift13', followers: '89.2M', following: false },
   { name: 'Fashion Nova', username: '@fashionnova', followers: '21.3M', following: true },
   { name: 'Zendaya', username: '@zendaya', followers: '184.5M', following: false }
];

export const shopData = {
   brands: [
      { name: 'Zara', discount: 25, exclusiveItems: 15, tier: 'Gold Partner' },
      { name: 'H&M', discount: 20, exclusiveItems: 12, tier: 'Silver Partner' },
      { name: 'Nike', discount: 30, exclusiveItems: 8, tier: 'Platinum Partner' },
      { name: 'Adidas', discount: 25, exclusiveItems: 10, tier: 'Gold Partner' },
      { name: 'Uniqlo', discount: 15, exclusiveItems: 6, tier: 'Bronze Partner' }
   ],

   featuredItems: [
      {
         brand: 'Nike',
         item: 'Air Force 1 x ILYO Edition',
         originalPrice: 120,
         discountedPrice: 84,
         pointsDiscount: 1000,
         exclusive: true,
         image: '/api/placeholder/150/200',
         description: 'Limited edition collaboration with ILYO users'
      },
      {
         brand: 'Zara',
         item: 'Minimalist Blazer',
         originalPrice: 89,
         discountedPrice: 67,
         pointsDiscount: 500,
         exclusive: false,
         image: '/api/placeholder/150/200'
      },
      {
         brand: 'H&M',
         item: 'Sustainable Cotton Tee',
         originalPrice: 12,
         discountedPrice: 10,
         pointsDiscount: 200,
         exclusive: true,
         image: '/api/placeholder/150/200',
         description: 'Eco-friendly exclusive for ILYO community'
      }
   ],

   pointsRewards: [
      { points: 500, reward: 'Extra 10% off any purchase', icon: '💰' },
      { points: 1000, reward: 'Free shipping on next order', icon: '🚚' },
      { points: 1500, reward: '$20 ILYO credit', icon: '💳' },
      { points: 2000, reward: 'VIP early access to sales', icon: '⭐' },
      { points: 5000, reward: 'Personal stylist session', icon: '👗' }
   ],

   charityPartners: [
      { name: 'Dress for Success', focus: 'Professional attire for women', impact: '2,847 outfits donated' },
      { name: 'Goodwill', focus: 'Job training & community support', impact: '15,392 items donated' },
      { name: 'The Salvation Army', focus: 'Family assistance programs', impact: '8,561 items donated' },
      { name: 'Local Homeless Shelter', focus: 'Warm clothing for winter', impact: '1,298 items donated' }
   ],

   sellableItems: [
      { item: 'White Button Down', brand: 'Uniqlo', condition: 'Good', estimatedPoints: 45, worn: '3 days ago' },
      { item: 'Black Turtleneck', brand: 'COS', condition: 'Excellent', estimatedPoints: 85, worn: '1 week ago' },
      { item: 'Navy Blazer', brand: 'Zara', condition: 'Like New', estimatedPoints: 120, worn: '5 days ago' },
      { item: 'Running Shoes', brand: 'Nike', condition: 'Fair', estimatedPoints: 35, worn: '3 days ago' },
      { item: 'Leather Belt', brand: 'Coach', condition: 'Good', estimatedPoints: 95, worn: '3 days ago' }
   ]
};